import React from "react";
import { Button, Tooltip, Text } from "@showitinc/showit-wc";
import cx from "classnames";

import uiPrefix from "@/utils/UiPrefixUtils";
import MediaSelectHandler from "@/components/utils/MediaSelectHandler";
import DocumentStore from "@/document/DocumentStore";
import { COMMANDS } from "@/document/commands";
import ImageActions from "@/actions/ImageActions";
// initializes store. Don't delete
import ImageStore from "@/stores/ImageStore";

import { CROP_MODE } from "@/constants/UIConstants";

import styles from "../ElementToolbar.module.css";

const ImageToolbarButtons = ({ selectedElementsData, selectedElements, selectedBlock, mode }) => {
  const elementId = selectedElements.first()?.id;

  const element = selectedElementsData.first();
  const graphic = element.get("content", false);
  const aspectRatio = graphic.get("aspect_ratio", false);
  const locked = !!element.get("lockEditing");
  const isPlaceholder = graphic.get("key") === undefined;

  if (locked) return null;

  const cropActive = mode === CROP_MODE;

  const assetSelectionHandler = () =>
    MediaSelectHandler.selectMedia(elementId, element, { type: "image" });
  const cancelCrop = () => ImageActions.exitCropMode();
  const completeCrop = () => ImageActions.exitAndSaveCropMode(element);
  const startCrop = () => ImageActions.enterCropMode(element, selectedBlock);
  const resize = () =>
    DocumentStore.dispatch({
      type: COMMANDS.RESIZE_TO_ASPECT_RATIO,
      payload: [element, elementId, aspectRatio],
    });

  return !locked ? (
    <>
      {!cropActive && (
        <>
          <Tooltip delay={10} position="top-center" positionType="absolute">
            <Button
              variant="icon"
              data-e2e={uiPrefix("swap-image-btn")}
              className={styles["toolbar-btn"]}
              onClick={assetSelectionHandler}
              iconPrefix="galleryElement"
              iconSize="20"
            />
            <span slot="content">
              <Text className={styles.label}>Swap Image</Text>
            </span>
          </Tooltip>
          {!isPlaceholder && (
            <>
              <Tooltip delay={10} position="top-center" positionType="absolute">
                <Button
                  variant="icon"
                  data-e2e={uiPrefix("resize-aspect-btn")}
                  className={styles["toolbar-btn"]}
                  onClick={resize}
                  iconPrefix="imageReset"
                  iconSize="20"
                />
                <span slot="content">
                  <Text className={styles.label}>Reset</Text>
                </span>
              </Tooltip>
              <Tooltip delay={10} position="top-center" positionType="absolute">
                <Button
                  variant="icon"
                  data-e2e={uiPrefix("crop-image-btn")}
                  className={styles["toolbar-btn"]}
                  onClick={startCrop}
                  iconPrefix="crop"
                  iconSize="20"
                />
                <span slot="content">
                  <Text className={styles.label}>Crop Image</Text>
                </span>
              </Tooltip>
            </>
          )}
        </>
      )}

      {cropActive && !locked && (
        <>
          <Button
            variant="icon"
            data-e2e={uiPrefix("resize-aspect-btn")}
            className={styles["toolbar-btn"]}
            onClick={cancelCrop}
            iconPrefix="close"
            iconSize="20"
          />
          <Tooltip delay={10} position="top-center" positionType="absolute">
            <Button
              variant="icon"
              data-e2e={uiPrefix("complete-crop-btn")}
              className={cx([styles["toolbar-btn"], styles.commit])}
              onClick={completeCrop}
              iconPrefix="check"
              iconSize="20"
            />
            <span slot="content">
              <Text className={styles.label}>Complete Crop</Text>
            </span>
          </Tooltip>
        </>
      )}
    </>
  ) : null;
};

export default ImageToolbarButtons;
